module.exports = __webpack_public_path__ + "img/cdn24.2b0a461.svg";